import React from 'react';
import './LegalList.css';
import Card from './Card';

export default ({ legalItems }) => {
  return (
    <div className="legal-list">
      {legalItems.map(({ titulo, url }, i) => (
        <Card key={i}>
          <a
            className="legal-item"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="material-icons legal-item__icon">subject</i>
            <h4 className="legal-item__title">{titulo}</h4>
            <div className="btn">Abrir pdf</div>
          </a>
        </Card>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LegalList.js